var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElmaCortexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64113 24.6636V19.9985L2 25.6431C2.50507 32.5401 8.27247 37.9969 15.2957 37.9969H19.9608V32.3148H15.2957C11.0743 32.3148 7.64113 28.8817 7.64113 24.6636Z",
    fill: "#5AD2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3143 15.3367V19.9984L37.9589 14.3538C37.4538 7.46025 31.6864 2 24.6632 2H19.998V7.68208H24.6632C28.8812 7.68208 32.3143 11.1152 32.3143 15.3367Z",
    fill: "#FABE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3367 7.68312H19.9984L14.3538 2.04199C7.46025 2.54365 2 8.31446 2 15.3377V20.0028H7.68208V15.3377C7.68208 11.1163 11.1152 7.68312 15.3367 7.68312Z",
    fill: "#E62D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 20.3755L31.5555 26.8201L38.0001 29.188L31.5555 31.556L29.1875 38.0006L26.8196 31.556L20.375 29.188L26.8196 26.8201L29.1875 20.3755Z",
    fill: "#5082E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElmaCortexLogo);
export default __webpack_public_path__ + "clientapp/media/elma-cortex-logo.d7a6a92c.svg";
export { ForwardRef as ReactComponent };